import { TRuleWithTheme } from 'styles/theme';

export const reasons: TRuleWithTheme = () => ({
    flexDirection: 'column',
    alignItems: 'flex-start',
});

export const reason: TRuleWithTheme = () => ({
    '&.ant-typography': {
        marginBottom: '0.5rem',
    },
});
